import { render, staticRenderFns } from "./learningCentreAdd.vue?vue&type=template&id=b116aba6&scoped=true&"
import script from "./learningCentreAdd.vue?vue&type=script&lang=js&"
export * from "./learningCentreAdd.vue?vue&type=script&lang=js&"
import style0 from "./learningCentreAdd.vue?vue&type=style&index=0&id=b116aba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b116aba6",
  null
  
)

export default component.exports